import { createUseStyles } from 'react-jss'
import LeftArrow from '../../assets/icons/icon_left_arrow.svg'
import RightArrow from '../../assets/icons/icon_right_arrow.svg'

const useStyles = createUseStyles((theme) => ({
  container: {
    width: '100%',
    margin: [[20, 'auto', 0]],
    display: 'flex',
    justifyContent: 'center',
  },
  paginationStyle: {
    display: 'flex',
    listStyleType: 'none',
    margin: 0,
    '& li': {
      textAlign: 'center',
      width: '3rem',
      margin: '0 0.8rem',
      display: 'inline-block',
      height: '3rem',
      cursor: 'pointer',
      '& a': {
        height: '3rem',
        width: '3rem',
        display: 'block',
        position: 'relative',
      },
      '&.active': {
        color: theme.colors.background,
        background: theme.colors.primary,
      },
      '&.icon a': {
        width: '3rem',
        display: 'block',
        height: '3rem',
      },
      '&.icon.icon-left a:before': {
        width: '4.4rem',
        height: '4.4rem',
        content: `url(${LeftArrow})`,
      },
      '&.icon.icon-right a:before': {
        width: '4.4rem',
        height: '4.4rem',
        content: `url(${RightArrow})`,
      },
    },
  },
  [`@media (min-width: ${theme.mediaQueries.desktop}px)`]: {
    container: {
      width: '100%',
    },
  },
}))

export default useStyles
